import { render, staticRenderFns } from "./APIRequestHistorical.vue?vue&type=template&id=24a0da97&"
import script from "./APIRequestHistorical.vue?vue&type=script&lang=js&"
export * from "./APIRequestHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports